import axios from 'axios';

const baseApiUrl = 'api/v1/user-notifications';

export default class UserNotificationService {
  public retrieve(param: any): Promise<any> {
    let query = `?shopId=${param.shopId}&size=${param.size}`;
    if (!param.size) {
      query = `?shopId=${param.shopId}`;
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + query)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public patch(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .patch(baseApiUrl + `/${id}/viewed`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
